module.exports = __webpack_public_path__ + "static/media/roble_amarone.2b33c2a3.jpg";